import React from "react";
import { useSavedProperties } from "../../hooks/useSavedProperties";

interface PropertySaveButtonProps {
  propertyId: number;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const PropertySaveButton: React.FC<PropertySaveButtonProps> = ({
  propertyId,
  className = "",
  onClick,
}) => {
  const { isSaved, toggleSave } = useSavedProperties();
  const saved = isSaved(propertyId);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    toggleSave(propertyId);
    onClick?.(e);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center justify-center w-10 h-10 rounded-full border border-solid transition-colors ${
        saved
          ? "bg-brand-yellow border-brand-yellow text-text-obsidian"
          : "bg-white/90 border-[rgba(0,0,0,0.12)] text-text-obsidian hover:border-brand-yellow hover:text-brand-gold"
      } ${className}`}
      aria-label={saved ? "Remove from saved properties" : "Save property"}
      aria-pressed={saved}
    >
      <span className="text-lg leading-none" aria-hidden="true">
        {saved ? "♥" : "♡"}
      </span>
    </button>
  );
};

export default PropertySaveButton;
